import React from 'react'

import '../styles/normalize.css'
import '../styles/index.css'

const Layout = ({ children }) => <main>{children}</main>

export default Layout
